export default "__VITE_ASSET__DDVl0TAK__"